import { upperFirst } from "es-toolkit";

//#region ../base/upload/util.ts
/**
* Sanitize filename string
*/
function cleanFilename(name) {
	if (typeof name === "undefined") return;
	const parts = name.split(".");
	if (parts.length >= 2) parts.pop();
	return parts.join(".").replace(/(_|-{2,})/g, " ").replace(/\w\S*/g, (txt) => {
		return upperFirst(txt);
	});
}

//#endregion
export { cleanFilename };